import { SUB_VERSION_MIGRATION, SUB_EX_COMMISSION } from '@/store/const/expertise'

export const EX_COMMISSION_QUESTIONS_TEMPLATE_VERSION = 1

export const DEFAULT_COMMISSION_QUESTION = () => ({
  text: '',
})

export const DEFAULT_COMMISSION_PARTICIPANT = title => ({
  title: title || '',
  questions: [DEFAULT_COMMISSION_QUESTION()],
})

export const DEFAULT_COMMISSION_PARTICIPANTS = () => [
  DEFAULT_COMMISSION_PARTICIPANT('Главный внештатный специалист'),
  DEFAULT_COMMISSION_PARTICIPANT('ЦЭККМП'),
  DEFAULT_COMMISSION_PARTICIPANT('Заявитель'),
]

export const EX_COMMISSION_QUESTIONS_TEMPLATE = () => ({
  hasQuestions: false,
  participants: DEFAULT_COMMISSION_PARTICIPANTS(),
})

export function participantTabLabel(participant, index) {
  const title = String(participant?.title || '').trim()
  if (!title) return `Участник ${index + 1}`
  if (title.length <= 14) return title
  return `${title.slice(0, 14)}…`
}

export function normalizeCommissionQuestions(raw) {
  if (!raw || typeof raw !== 'object') {
    return EX_COMMISSION_QUESTIONS_TEMPLATE()
  }
  const participants = Array.isArray(raw.participants)
    ? raw.participants.map(p => {
        let title = p?.title ?? ''
        if (String(title).trim() === 'ЦЭКМП') title = 'ЦЭККМП'
        return {
          title,
          questions:
            Array.isArray(p?.questions) && p.questions.length
              ? p.questions.map(q => ({
                  text: q?.text ?? '',
                }))
              : [DEFAULT_COMMISSION_QUESTION()],
        }
      })
    : DEFAULT_COMMISSION_PARTICIPANTS()

  return {
    hasQuestions: !!raw.hasQuestions,
    participants: participants.length
      ? participants
      : DEFAULT_COMMISSION_PARTICIPANTS(),
  }
}

SUB_VERSION_MIGRATION[SUB_EX_COMMISSION].v =
  EX_COMMISSION_QUESTIONS_TEMPLATE_VERSION
